import script from "./admin-estimate-list.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-estimate-list.vue?vue&type=script&setup=true&lang=js"

import "./admin-estimate-list.vue?vue&type=style&index=0&id=9634d976&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9634d976"]])

export default __exports__